import React, {memo, useState, useCallback} from 'react';
import PropTypes from 'prop-types';
import styles from './index.less';
import { Card, Input } from 'antd';
import TemplateDetailsFooterActions from '@/modules/templates/components/TemplateDetailsFooterActions';
import {useCrudRunAudit} from '@/modules/auditorAudits/hooks/useAuditorAudits';
import {useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useAuditData} from '@/modules/auditorAudits/hooks/useAuditData';

const TemplateDetailPoolsNumbers = ({sectionId, question, isCover, runAudit}) => {
  const {t} = useTranslation('templates');
  const { updateContact } = useCrudRunAudit();
  const {id} = useParams();

  const {currentAudit} = useAuditData();

  const [number, setNumber] = useState(currentAudit?.contactFields?.find(x => x?._id === question?._id)?.value || '');

  const onSave = useCallback(async () => {
    if (runAudit) {
      const contactFields = {
        _id: question?._id,
        value: number
      };
      await updateContact({ auditId: id, contactFields});
    }
  }, [updateContact, id, number, runAudit, question._id ]);

  return (
    <Card
      className={styles.templateNumberCard}
      id={'question-view-'+question?._id}
    >
      <div className="mb-3">
        {question?.type === 'pools_reported' ? 
          t('details.poolsReported') :
          question?.type === 'pools_audited' ? 
            t('details.poolsAudited') : t('details.poolsNotudited')
        }
      </div>
      <div className="custom-form-big mb-3">

        <Input type="number" value={number} className="mb-3" onChange={e => setNumber(e?.target?.value)} onPressEnter={e => {
          e.preventDefault();
          e.stopPropagation();
          if (runAudit) {
            onSave().then();
          }
        }}
        onBlur={onSave}
        />

      </div>

      { !isCover && <TemplateDetailsFooterActions question={ question } sectionId={ sectionId } runAudit={ runAudit } /> }
    </Card>
  );
};

TemplateDetailPoolsNumbers.propTypes = {
  runAudit: PropTypes.bool,
  sectionId: PropTypes.string,
  question: PropTypes.object,
  isCover: PropTypes.bool,
};
TemplateDetailPoolsNumbers.defaultProps = {
  question: {},
};

export default memo(TemplateDetailPoolsNumbers);


/**
 * cellRender
 * */
/**
 * This is not a components,
 * it is a function to render the Detail Audit Card components in a detail drawer
 * @param {String} value this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} entity this is the row instance
 * */
export const renderTemplateDetailPoolsNumbers = (value, entity) => {
  return (
    <TemplateDetailPoolsNumbers entity={entity}/>
  );
};
